import { render, staticRenderFns } from "./EditSocialIconsTabIcon.vue?vue&type=template&id=0c20308d&scoped=true&"
import script from "./EditSocialIconsTabIcon.vue?vue&type=script&lang=js&"
export * from "./EditSocialIconsTabIcon.vue?vue&type=script&lang=js&"
import style0 from "./EditSocialIconsTabIcon.vue?vue&type=style&index=0&id=0c20308d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c20308d",
  null
  
)

export default component.exports